import useAuth from '../../../auth/useAuth';

import SwitchButton from '../../../../components/Forms/SwitchButton';

import { Tooltip } from '@material-ui/core';
import { useAppDispatch } from '../../../../App/redux/store';
import Button from '../../../../components/Assets/Button';
import { modalsActions } from '../../../modals/modalsSlice';
import { updateUserThunk } from '../../services/usersThunks';
import './userCard.scss';

interface IUserCardProps {
  user: IUser;
}

function UserCard({ user }: IUserCardProps) {
  const { isManager, userIdIri } = useAuth({});
  const dispatch = useAppDispatch();

  const handleEnableUser = () => {
    dispatch(
      updateUserThunk({
        idIri: user.idIri,
        body: { enabled: !user.enabled },
      }),
    );
  };

  const handleUpdateUser = (user: IUser) => {
    dispatch(modalsActions.createOrUpdateUser({ open: true, entity: user }));
  };

  const handleUserRole = () => {
    return user.roles.includes('ROLE_ADMIN')
      ? 'Admin'
      : user.roles.includes('ROLE_MANAGER')
      ? 'Manager'
      : 'Prospecteur';
  };

  return (
    <div className="team-card">
      <div className="team-card-people">
        {isManager && (
          <div className="team-card-admin">
            <div>
              <SwitchButton
                label={
                  user.hasPasswordSet
                    ? user.enabled
                      ? 'Activé'
                      : 'desactivé'
                    : 'Non finalisé'
                }
                checked={user.enabled}
                handleChange={handleEnableUser}
                name="enabled"
                labelPlacement="top"
                disabled={user.idIri === userIdIri}
              />
            </div>
            <Button
              btnType="button"
              btnContent="Modifier"
              handleClick={() => handleUpdateUser(user)}
              primary
            />
          </div>
        )}
        <h3 className="team-card-name">{`${user.firstName} ${user.lastName}`}</h3>
        {user.email.length <= 28 ? (
          <span className="team-card-mail">{user.email}</span>
        ) : (
          <Tooltip title={user.email} placement="top" interactive>
            <span className="team-card-mail">{user.email.substring(0, 25)}...</span>
          </Tooltip>
        )}
      </div>

      <div className="team-card-footer">
        {user.roles && <span>{handleUserRole()}</span>}
      </div>
    </div>
  );
}

export default UserCard;
